import { useEffect } from 'react';

import { useLatest } from '../UseLatest';

/**
 * Hook that alerts clicks outside of the passed ref
 */
export const useOutsideClick = (ref: any, outSideClick: any, attached = true) => {
  const latestHandler = useLatest(outSideClick);

  useEffect(() => {
    if (!attached) return;

    const handleClick = (e: any) => {
      if (!ref.current) return;
      if (!ref.current.contains(e.target)) {
        latestHandler.current();
      }
    };

    setTimeout(() => {
      document.addEventListener('click', handleClick);
    }, 0);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [ref, outSideClick, attached]);
};
